import * as React from "react";
const SvgLogoWashmaster = (props) => /* @__PURE__ */ React.createElement("svg", {
	"xmlns:dc": "http://purl.org/dc/elements/1.1/",
	"xmlns:cc": "http://creativecommons.org/ns#",
	"xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
	"xmlns:svg": "http://www.w3.org/2000/svg",
	xmlns: "http://www.w3.org/2000/svg",
	"xmlns:sodipodi": "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
	"xmlns:inkscape": "http://www.inkscape.org/namespaces/inkscape",
	id: "Ebene_1",
	x: "0px",
	y: "0px",
	viewBox: "0 0 359.99999 61.999999",
	xmlSpace: "preserve",
	"sodipodi:docname": "washMaster Logo Adyen Skin.svg",
	width: "100%",
	"inkscape:version": "0.92.0 r15299",
	"inkscape:export-filename": "\\\\\\\\\\\\\\\\SMWOS004\\\\\\\\Fachbereiche\\\\\\\\Forschung\\\\\\\\Projekte\\\\\\\\41604_Connectivity\\\\\\\\02_Pflichtenheft\\\\\\\\UI Design\\\\\\\\Adyen Skin\\\\\\\\washMaster Logo Adyen Skin.big.png",
	"inkscape:export-xdpi": 106.67,
	"inkscape:export-ydpi": 106.67,
	...props
}, /* @__PURE__ */ React.createElement("metadata", { id: "metadata45" }, /* @__PURE__ */ React.createElement("rdf:RDF", null, /* @__PURE__ */ React.createElement("cc:Work", { "rdf:about": "" }, /* @__PURE__ */ React.createElement("dc:format", null, "image/svg+xml"), /* @__PURE__ */ React.createElement("dc:type", { "rdf:resource": "http://purl.org/dc/dcmitype/StillImage" }), /* @__PURE__ */ React.createElement("dc:title", null)))), /* @__PURE__ */ React.createElement("defs", { id: "defs43" }), /* @__PURE__ */ React.createElement("sodipodi:namedview", {
	pagecolor: "#ffffff",
	bordercolor: "#666666",
	borderopacity: 1,
	objecttolerance: 10,
	gridtolerance: 10,
	guidetolerance: 10,
	"inkscape:pageopacity": 0,
	"inkscape:pageshadow": 2,
	"inkscape:window-width": 1920,
	"inkscape:window-height": 1058,
	id: "namedview41",
	showgrid: "false",
	"inkscape:zoom": 1.0288065,
	"inkscape:cx": 128.73289,
	"inkscape:cy": 30.286339,
	"inkscape:window-x": -8,
	"inkscape:window-y": -8,
	"inkscape:window-maximized": 1,
	"inkscape:current-layer": "layer2"
}), /* @__PURE__ */ React.createElement("style", {
	type: "text/css",
	id: "style2"
}, "\n	.st0{fill-rule:evenodd;clip-rule:evenodd;fill:none;}\n"), /* @__PURE__ */ React.createElement("g", {
	"inkscape:groupmode": "layer",
	id: "layer1",
	"inkscape:label": "Background",
	style: { display: "none" },
	transform: "translate(-0.61377317,-0.34252453)"
}, /* @__PURE__ */ React.createElement("rect", {
	style: {
		fill: "#4e4d50",
		fillOpacity: 1,
		stroke: "none",
		strokeWidth: 1.2221241,
		strokeMiterlimit: 4,
		strokeDasharray: "none",
		strokeDashoffset: 0,
		strokeOpacity: 1
	},
	id: "rect4522",
	width: 360,
	height: 62,
	x: .61377317,
	y: .34252453
})), /* @__PURE__ */ React.createElement("g", {
	"inkscape:groupmode": "layer",
	id: "layer2",
	shapeRendering: "geometricPrecision",
	"inkscape:label": "Logo",
	transform: "translate(-0.61377317,-0.34252453)"
}, /* @__PURE__ */ React.createElement("polygon", {
	transform: "translate(13.131281,-10.971851)",
	points: "",
	id: "polygon30",
	style: {
		fill: "#fffffd",
		fillOpacity: 1,
		stroke: "#fffffa",
		strokeOpacity: 1
	}
}), /* @__PURE__ */ React.createElement("g", {
	id: "g4529",
	transform: "translate(-7)"
}, /* @__PURE__ */ React.createElement("g", {
	transform: "translate(24.477648,-10.882475)",
	id: "g26",
	style: {
		fill: "#fffffd",
		fillOpacity: 1,
		stroke: "#fffffa",
		strokeWidth: 1.5,
		strokeMiterlimit: 4,
		strokeDasharray: "none",
		strokeOpacity: 1
	}
}, /* @__PURE__ */ React.createElement("path", {
	d: "M 87.7,57.6 H 87.1 L 80.9,36.8 74.6,57.6 H 74 L 65.6,30 h 2.8 l 6,21.3 6.1,-21.3 h 1 l 6,21.3 6.1,-21.3 h 2.7 z",
	id: "path6",
	"inkscape:connector-curvature": 0,
	style: {
		fill: "#fffffd",
		fillOpacity: 1,
		stroke: "#fffffa",
		strokeWidth: 1.5,
		strokeMiterlimit: 4,
		strokeDasharray: "none",
		strokeOpacity: 1
	}
}), /* @__PURE__ */ React.createElement("path", {
	d: "m 116.1,55.4 c -2.7,0.8 -7.3,2.3 -8.7,2.3 -5.4,0 -8.5,-3.6 -8.5,-7.8 0,-3.9 1.7,-8.1 7.9,-8.1 h 9.3 v -4.2 c 0,-3.8 -1.7,-5.4 -6.3,-5.4 -2.1,0 -5,0.8 -7.9,2.2 l -1,-2 c 2.5,-1.2 6.4,-2.5 9.2,-2.5 5.7,0 8.6,1.3 8.6,7.7 v 17.2 l 0.8,2.5 -2,0.5 z m -8.6,-11.5 c -5.2,0 -6.4,2.2 -6.4,5.8 0,3.1 1.4,5.9 7.1,5.9 1,0 5.1,-1.3 7.7,-2.3 v -9.5 h -8.4 z",
	id: "path8",
	"inkscape:connector-curvature": 0,
	style: {
		fill: "#fffffd",
		fillOpacity: 1,
		stroke: "#fffffa",
		strokeWidth: 1.5,
		strokeMiterlimit: 4,
		strokeDasharray: "none",
		strokeOpacity: 1
	}
}), /* @__PURE__ */ React.createElement("path", {
	d: "m 123.9,54.9 0.9,-2.2 c 2.8,1.4 6.3,2.6 8.9,2.6 5.6,0 7.8,-2.4 7.8,-5.9 0,-2.4 -3,-3.7 -5,-4.4 l -4.7,-1.7 c -4.3,-1.6 -6.9,-3.5 -6.9,-6.9 0,-4.7 2.9,-6.9 8.2,-6.9 2.3,0 6.4,0.7 9.9,2.3 l -0.9,2 c -3.7,-1.6 -6.5,-2 -8.5,-2 -3.8,0 -5.9,1.3 -5.9,4.3 0,2 1.7,3.5 4.3,4.6 1.3,0.5 2.8,1 4.1,1.5 5.5,2 8,3.1 8,7.2 0,4.5 -2.5,8.2 -10.3,8.2 -2.2,0 -6.4,-0.9 -9.9,-2.7 z",
	id: "path10",
	"inkscape:connector-curvature": 0,
	style: {
		fill: "#fffffd",
		fillOpacity: 1,
		stroke: "#fffffa",
		strokeWidth: 1.5,
		strokeMiterlimit: 4,
		strokeDasharray: "none",
		strokeOpacity: 1
	}
}), /* @__PURE__ */ React.createElement("path", {
	d: "m 166.7,41.2 c 0,-4.8 -0.3,-9.1 -5.1,-9.1 -2,0 -6,1.1 -9.3,2.6 v 22.7 h -2.6 V 19 h 2.6 v 13.3 c 3.2,-1.1 7.7,-2.5 10.4,-2.5 3.5,0 6.6,2.2 6.6,9.1 v 18.6 h -2.6 z",
	id: "path12",
	"inkscape:connector-curvature": 0,
	style: {
		fill: "#fffffd",
		fillOpacity: 1,
		stroke: "#fffffa",
		strokeWidth: 1.5,
		strokeMiterlimit: 4,
		strokeDasharray: "none",
		strokeOpacity: 1
	}
}), /* @__PURE__ */ React.createElement("path", {
	d: "m 207.9,25.5 -0.3,0.1 -12.9,31.8 h -2.3 L 179.6,25.7 h -0.3 v 31.7 h -2.5 V 19 h 2.9 L 193.5,53.5 207.3,19 h 3 v 38.4 h -2.5 z",
	id: "path14",
	"inkscape:connector-curvature": 0,
	style: {
		fill: "#fffffd",
		fillOpacity: 1,
		stroke: "#fffffa",
		strokeWidth: 1.5,
		strokeMiterlimit: 4,
		strokeDasharray: "none",
		strokeOpacity: 1
	}
}), /* @__PURE__ */ React.createElement("path", {
	d: "m 233.7,55.4 c -2.7,0.8 -7.3,2.3 -8.7,2.3 -5.4,0 -8.5,-3.6 -8.5,-7.8 0,-3.9 1.7,-8.1 7.9,-8.1 h 9.3 v -4.2 c 0,-3.8 -1.7,-5.4 -6.3,-5.4 -2.1,0 -5,0.8 -7.9,2.2 l -1,-2 c 2.5,-1.2 6.4,-2.5 9.2,-2.5 5.7,0 8.6,1.3 8.6,7.7 v 17.2 l 0.8,2.5 -2,0.5 z m -8.6,-11.5 c -5.2,0 -6.4,2.2 -6.4,5.8 0,3.1 1.4,5.9 7.1,5.9 1,0 5.1,-1.3 7.7,-2.3 v -9.5 h -8.4 z",
	id: "path16",
	"inkscape:connector-curvature": 0,
	style: {
		fill: "#fffffd",
		fillOpacity: 1,
		stroke: "#fffffa",
		strokeWidth: 1.5,
		strokeMiterlimit: 4,
		strokeDasharray: "none",
		strokeOpacity: 1
	}
}), /* @__PURE__ */ React.createElement("path", {
	d: "m 241.5,54.9 0.9,-2.2 c 2.8,1.4 6.3,2.6 8.9,2.6 5.6,0 7.8,-2.4 7.8,-5.9 0,-2.4 -3,-3.7 -5,-4.4 l -4.7,-1.7 c -4.3,-1.6 -6.9,-3.5 -6.9,-6.9 0,-4.7 2.9,-6.9 8.2,-6.9 2.3,0 6.4,0.7 9.9,2.3 l -0.9,2 c -3.7,-1.6 -6.5,-2 -8.5,-2 -3.8,0 -5.9,1.3 -5.9,4.3 0,2 1.7,3.5 4.3,4.6 1.3,0.5 2.8,1 4.1,1.5 5.5,2 8,3.1 8,7.2 0,4.5 -2.5,8.2 -10.3,8.2 -2.2,0 -6.4,-0.9 -9.9,-2.7 z",
	id: "path18",
	"inkscape:connector-curvature": 0,
	style: {
		fill: "#fffffd",
		fillOpacity: 1,
		stroke: "#fffffa",
		strokeWidth: 1.5,
		strokeMiterlimit: 4,
		strokeDasharray: "none",
		strokeOpacity: 1
	}
}), /* @__PURE__ */ React.createElement("path", {
	d: "M 269.2,51.6 V 32.5 H 266 v -2.2 h 3.2 v -4.5 l 1.2,-4 h 1.4 v 8.5 h 6.9 v 2.2 h -6.9 v 18.3 c 0,3.2 1.2,4.6 4.4,4.6 1.4,0 3.2,-0.6 5.1,-1.3 l 0.6,2.2 c -1.9,0.7 -4.5,1.5 -6.4,1.5 -4,-0.1 -6.3,-2.2 -6.3,-6.2 z",
	id: "path20",
	"inkscape:connector-curvature": 0,
	style: {
		fill: "#fffffd",
		fillOpacity: 1,
		stroke: "#fffffa",
		strokeWidth: 1.5,
		strokeMiterlimit: 4,
		strokeDasharray: "none",
		strokeOpacity: 1
	}
}), /* @__PURE__ */ React.createElement("path", {
	d: "m 285.4,43.7 c 0,-9.3 2.3,-13.9 10.4,-13.9 8.1,0 10.4,4.6 10.4,14.1 v 1 h -18 c 0.2,5.8 0.6,10.4 7.6,10.4 3.2,0 6.1,-1.1 8.8,-2.5 l 0.9,2.1 c -3.5,1.8 -7.7,2.8 -9.9,2.8 -7.8,-0.1 -10.2,-4.8 -10.2,-14 z m 2.8,-1 h 15.2 c 0,-7.9 -2,-10.8 -7.6,-10.8 -5.1,0 -7.6,2.4 -7.6,10.8 z",
	id: "path22",
	"inkscape:connector-curvature": 0,
	style: {
		fill: "#fffffd",
		fillOpacity: 1,
		stroke: "#fffffa",
		strokeWidth: 1.5,
		strokeMiterlimit: 4,
		strokeDasharray: "none",
		strokeOpacity: 1
	}
}), /* @__PURE__ */ React.createElement("path", {
	d: "m 324.9,32.5 c -1.2,0 -2.9,0.1 -3.9,0.5 -2.3,0.9 -3,1.4 -5.6,3.4 v 20.9 h -2.6 v -23 l -1.3,-3.6 2.3,-0.8 1.6,3.5 c 3,-1.8 3.9,-2.5 6.1,-3.2 1,-0.3 2.5,-0.4 3.6,-0.4 z",
	id: "path24",
	"inkscape:connector-curvature": 0,
	style: {
		fill: "#fffffd",
		fillOpacity: 1,
		stroke: "#fffffa",
		strokeWidth: 1.5,
		strokeMiterlimit: 4,
		strokeDasharray: "none",
		strokeOpacity: 1
	}
})), /* @__PURE__ */ React.createElement("path", {
	style: {
		fill: "#fffffd",
		fillOpacity: 1,
		stroke: "#fffffa",
		strokeWidth: .60000002,
		strokeMiterlimit: 4,
		strokeDasharray: "none",
		strokeOpacity: 1
	},
	"inkscape:connector-curvature": 0,
	id: "path28",
	d: "m 47.377648,39.417525 c -3.6,0 -6.6,-2.9 -6.6,-6.6 0,-3.6 2.9,-6.6 6.6,-6.6 3.6,0 6.6,2.9 6.6,6.6 -0.1,3.7 -3,6.6 -6.6,6.6 z m 0,-10.4 c -2.1,0 -3.799999,1.7 -3.799999,3.8 0,2.1 1.7,3.8 3.799999,3.8 2.1,0 3.8,-1.7 3.8,-3.8 0,-2 -1.7,-3.8 -3.8,-3.8 z"
}), /* @__PURE__ */ React.createElement("path", {
	style: {
		fill: "#fffffd",
		fillOpacity: 1,
		stroke: "#fffffa",
		strokeWidth: .60000002,
		strokeMiterlimit: 4,
		strokeDasharray: "none",
		strokeOpacity: 1
	},
	"inkscape:connector-curvature": 0,
	id: "path32",
	d: "m 55.477648,51.017525 c -2.299999,0.8 -5.1,1.4 -8.299999,1.4 -5,0 -10,-1.5 -14.8,-4.6 -0.7,-1 -2.8,-4.2 -3.9,-8.8 -1.7,-7.2 -0.5,-14.3 3.8,-21.1 1.6,-1 7.8,-4.5 15.6,-4.5 v -2.6 0 c -10,0 -17.5,5.2 -17.5,5.2 -11.9,18.5 0.2,33.7 0.2,33.7 6.1,3.9 11.8,5.3 16.6,5.3 3.1,0 5.9,-0.5 8.3,-1.3 1,-0.3 2,-0.7 2.9,-1.1 v -2.9 c -0.9,0.5 -1.9,0.9 -2.900001,1.3 z"
}), /* @__PURE__ */ React.createElement("path", {
	style: {
		fill: "#fffffd",
		fillOpacity: 1,
		stroke: "#fffffa",
		strokeWidth: .60000002,
		strokeMiterlimit: 4,
		strokeDasharray: "none",
		strokeOpacity: 1
	},
	"inkscape:connector-curvature": 0,
	id: "path34",
	d: "m 63.977648,16.017525 c -5.6,-3.9 -11.1,-5.2 -16.1,-5.2 v 2.6 0 c 5.1,0 9.9,1.5 14.300001,4.5 0.7,0.9 2.9,4 4.099999,8.6 1.6,5.9 0.8,11.8 -2.099999,17.6 -7.200001,0 -25,0 -25,0 l 0.2,-22 h 16.1 v 19.2 h 2.9 v -22 h -22 v 27.6 h 26.099999 3.1 c 0.5,-0.9 1,-1.8 1.4,-2.6 7.400001,-15.9 -3,-28.3 -3,-28.3 z"
}))));
export default SvgLogoWashmaster;
